module.exports = __webpack_public_path__ + "593b04cdccf78d12b46e29a17e857c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/trilliant@2x.png
// module id = 313
// module chunks = 0